import { FormattedAudio, FormattedVideo } from 'types/kontentAi';

export const selectVideoSource = (video: FormattedVideo) =>
  (video?.mp4File ? video.mp4File.url : video?.mp4Url) || '';

export const selectAudioSource = (audio?: FormattedAudio) =>
  (audio?.mp3File ? audio.mp3File.url : audio?.mp3Url) || '';
